export const processAvvData = (avvs) => {
  return avvs?.map((avv) => ({
    report_type: avv.report_type,
    search_string: avv.address,
    timestamp: avv.updated,
    status: avv.status,
    report_url: avv.report_url,
    updated: avv.updated,
  }));
};
